import $ from "jquery";
import { GameManager } from './managers/GameManager';
import WebFont from 'webfontloader';



export var LetteratiInstance = function (gameType: string, gameElement: HTMLDivElement, gameLevelComplete: (score:number,gameName:string, pracPlay:string) => void, gameEndFunction: (score:number,gameName:string, pracPlay:string) => void, gameData: any, pracPlay: string, htpShow: boolean, titleShow: boolean, previousScore: number, customTimeLimit: number | null, assetUrl: string) {
    (<GameManager>GameManager.instance).startGameLetterati(gameType, <any>gameElement, gameLevelComplete, gameEndFunction, gameData, pracPlay, htpShow, titleShow, previousScore, customTimeLimit, assetUrl);

    document.title = "Letterati";

    WebFont.load({
        custom: {
            families: ['London Between', 'Exo Medium', 'Exo Bold', 'Proximanova Black', 'Proximanova Regular', 'Airbag Free'],
            urls: [(<GameManager>GameManager.instance).assetUrl + '/assets/letterati/stylesheets/fonts.css']
        }
    });

    console.log('this is a test if it works hurrah');

    return {
        destroy: function () {
            (<GameManager>GameManager.instance).destroyGame();
        },
        restart: function () {
            (<GameManager>GameManager.instance).restartGame();
        }
    }
}



// Start Mock Initialization
var OnGameLevelComplete = function (score: number, gameName: string, puzzleName: string) {
    console.log("Game Level Complete External Call!");
    console.log(`Score: ${score} Game Name: ${gameName} Puzzle Name: ${puzzleName}`);
}

var OnGameEnd = function (score: number, gameName: string) {
    console.log("Game End External Call!");
    console.log(`Score: ${score} Game Name: ${gameName}`);
}



// End Mock Initialization